export default __webpack_public_path__ + "static/media/rcover.81e17ddb.png";